// App.tsx
import React, { useEffect } from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import AppRoutes from "./AppRoutes";

import dayjs from "dayjs";
import "dayjs/locale/ko";
import { logEvent } from "firebase/analytics";
import { analyticsPromise } from "./firebase";

// dayjs 로케일을 한글로 설정
dayjs.locale("ko");

// SPA 라우트 변경 시 page_view 이벤트 전송
const AnalyticsTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    analyticsPromise.then((analytics) => {
      if (!analytics) return;
      logEvent(analytics, "page_view", {
        page_path: location.pathname,
        page_location: window.location.href,
      });
    });
  }, [location]);

  return null;
};

const App: React.FC = () => {
  return (
    <Router>
      <AnalyticsTracker />
      <AppRoutes />
    </Router>
  );
};

export default App;
